// extracted by mini-css-extract-plugin
module.exports = {"label":"Checkbox_label__GGHTk","container":"Checkbox_container__bu5BA","input":"Checkbox_input__TTQbx"};